export default __webpack_public_path__ + "static/media/stained_mask.2f80e644.png";